import { Bulb } from '@/icons'
import { Button, Card, Stack, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { useTexts } from '../hooks/useTexts'

interface RestoreOrdersCardProps {
  onRestoreOrders: () => void
  loading: boolean
}

export function RestoreOrdersCard({ onRestoreOrders, loading }: RestoreOrdersCardProps) {
  const texts = useTexts()

  return (
    <Card
      elevation={1}
      sx={theme => ({ background: '#F3F5F7', borderRadius: 1, minHeight: theme.spacing(25) })}
      data-testid="restore-orders"
    >
      {!loading && (
        <Stack direction="row" spacing={2} padding={2}>
          <Bulb size={80} />

          <Stack direction="column" spacing={2}>
            <Typography variant="subtitle2">{texts.restoreOrdersTitle}</Typography>
            <Typography variant="body2">
              <FormattedMessage
                id={texts.restoreOrdersDescriptionId}
                values={{
                  br: <br />,
                }}
              />
            </Typography>

            <Button
              variant="contained"
              color="secondary"
              size="small"
              sx={{ width: 'fit-content' }}
              onClick={onRestoreOrders}
              data-testid="restore-orders-button"
              data-trackid="restore-orders-button"
            >
              {texts.restoreOrdersButtonText}
            </Button>
          </Stack>
        </Stack>
      )}
    </Card>
  )
}
